import { useCallback, useMemo } from "react";
import { useDashboardContext } from "../../../../contexts/dashboard-context";
import { useSelectedSpread } from "../../../../hooks/useSelection";
import { isBackgroundPatternPanelSupported } from "../menu-info";

export function useSetPatternBackground() {
	const spread = useSelectedSpread();

	const dashboard = useDashboardContext();

	const hook = useCallback(
		(bg: eXpress.core.Background) => {
			if (!spread) return;

			dashboard.applyBackgroundToSpread(spread, bg);
		},
		[dashboard, spread],
	);

	const isSupportedForZone = useMemo(
		() => isBackgroundPatternPanelSupported(spread, dashboard),
		[dashboard, spread],
	);

	return isSupportedForZone ? hook : undefined;
}
